// src/js/components/guideTooltipHandler.js

export function initializeGuideTooltip() {
    const resultsList = document.querySelector('.results-list');
    const tooltip = document.getElementById('guide-tooltip');
    const tooltipContent = document.getElementById('tooltip-content');
    const closeButton = tooltip ? tooltip.querySelector('.close-button') : null;
    
    const analysisData = window.AnalysisAreasData || [];
    let lastOpenedBy = null;

    if (!resultsList || !tooltip || !tooltipContent || !closeButton || analysisData.length === 0) return;

    const lang = document.documentElement.lang.startsWith('sv') ? 'sv' : 'en';

    const showTooltip = (resultItem) => {
        const itemId = resultItem.dataset.id;
        const itemData = analysisData.find(item => item.id === itemId);
        const description = itemData['description_' + lang] || itemData.description_en;
        const name = itemData['name_' + lang] || itemData.name_en;

        if (itemData && description) {
            tooltipContent.innerHTML = `<h4>${name}</h4><p>${description}</p>`;
            
            // ### NY, SMART POSITIONERINGSLOGIK ###
            const itemRect = resultItem.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect(); // Kräver att den inte har display:none
            const viewportWidth = window.innerWidth;
            const space = 10; // 10px marginal från kanter/objekt

            // Sätt den vertikala positionen (alltid under objektet)
            tooltip.style.top = `${itemRect.bottom + window.scrollY + space}px`;
            
            // Beräkna den ideala, centrerade horisontella positionen
            let idealLeft = itemRect.left + (itemRect.width / 2) - (tooltipRect.width / 2);

            // Justera om den går utanför skärmen
            if (idealLeft < space) {
                // För långt till vänster, justera mot vänsterkanten
                idealLeft = space;
            } else if (idealLeft + tooltipRect.width > viewportWidth - space) {
                // För långt till höger, justera mot högerkanten
                idealLeft = viewportWidth - tooltipRect.width - space;
            }
            
            tooltip.style.left = `${idealLeft}px`;
            tooltip.style.transform = 'none'; // Ta bort gammal transform

            tooltip.classList.add('is-visible');
            tooltip.setAttribute('aria-hidden', 'false');

            lastOpenedBy = resultItem;
            closeButton.focus();
        }
    };

    const hideTooltip = () => {
        if (lastOpenedBy) {
            lastOpenedBy.focus();
            lastOpenedBy = null;
        }
        setTimeout(() => {
            tooltip.classList.remove('is-visible');
            tooltip.setAttribute('aria-hidden', 'true');
        }, 0);
    };

    resultsList.addEventListener('click', (event) => {
        const resultItem = event.target.closest('.result-item');
        if (resultItem) {
            showTooltip(resultItem);
        }
    });

    closeButton.addEventListener('click', hideTooltip);
    document.addEventListener('click', (event) => {
        if (!event.target.closest('.result-item') && !event.target.closest('#guide-tooltip')) {
            hideTooltip();
        }
    }, true);
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && tooltip.classList.contains('is-visible')) {
            hideTooltip();
        }
    });
}